import React, { Dispatch, FC, SetStateAction } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { useTheme } from '@material-ui/core';
import logob from '../../../../assets/img/gotmy-n.png';

interface Props {
    email: string;
    isUserLoggedIn: boolean;
    event_thanks_video: string;
    modalPurchaseSuccess: boolean;
    setModalPurchaseSuccess: Dispatch<SetStateAction<boolean>>;
}

const ModalSuccess: FC<Props> = ({
    email,
    isUserLoggedIn,
    event_thanks_video,
    setModalPurchaseSuccess,
    modalPurchaseSuccess,
}) => {
    const theme = useTheme();
    return (
        <Modal show={modalPurchaseSuccess} onHide={() => setModalPurchaseSuccess(false)}>
            <Modal.Body>
                <div className="text-center d-flex flex-column justify-content-center align-items-center">
                    <img src={logob} className=" Logo" alt="logo" />
                    {event_thanks_video && (
                        <video
                            style={{ height: '380px', backgroundColor: 'black', objectFit: 'contain' }}
                            width="320"
                            height="340"
                            className="Video mt-4 br-10 mb-4"
                            controls={false}
                            autoPlay
                        >
                            <source src={event_thanks_video} type="video/mp4" />
                        </video>
                    )}
                    {isUserLoggedIn ? (
                        <>
                            <p className="Title2 mb-1">
                                {i18next.t('ModalSuccessEventBoughtComponentYouAreAmazing')}
                            </p>
                            <p className="Title2 mb-3">
                                {i18next.t('ModalSuccessEventBoughtComponentThankYouForBooking')}
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="Title2 mb-1">
                                {i18next.t('ModalSuccessEventBoughtComponentYouAreAmazing')}
                            </p>
                            <p className="Title2 mb-3">
                                {i18next.t('ModalSuccessEventBoughtComponentDownloadAppMessage')}
                            </p>
                        </>
                    )}

                    {isUserLoggedIn ? (
                        <Link style={{ color: theme.palette.primary.main }} to="/live_events">
                            {i18next.t('ModalSuccessEventBoughtComponentGoToMyLiveEvents')}
                        </Link>
                    ) : (
                        <Link className="Go" to="/">
                            {i18next.t('ModalSuccessEventBoughtComponentDiscoverMoreEvents')}
                        </Link>
                    )}

                    <p style={{ fontSize: '14px' }} className="mt-2">
                        {email && email.length > 0 && (
                            <span style={{ fontSize: '14px' }} className="mt-2">
                                {i18next.t('ModalSuccessEventBoughtComponentWeSentConfirmationEmailTo')}{' '}
                                {email}.{' '}
                            </span>
                        )}{' '}
                        {i18next.t('ModalSuccessEventBoughtComponentQuestionsRegardingYourEvent')}{' '}
                        <a style={{ color: theme.palette.primary.main }} href="mailto: support@gotmy.com">
                            support@gotmy.com
                        </a>
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default ModalSuccess;
